import React from 'react';
import { withLocalize } from "react-localize-redux";
import OldStyleSection from '../../common/oldStyleSection';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import BasicRow from '../../reportSections/identData/basicRow';

class AmlSearchCriteria extends React.Component {

    render() {
        if (this.props.asSection) {
            return (
                <div className="alone-section">
                    <OldStyleSection name={this.props.translate("Search.Cee.SearchParameters")} hasData={this.props.search} isOpen isBold>
                        <div className="card">
                            <div className="card-body">
                                {this.renderTable()}
                            </div>
                        </div>
                    </OldStyleSection >
                </div>
            )
        };

        return this.renderTable();
    }

    renderTable = () => {
        return (
            <div className="ident-data">
                <BasicRow title="Search.Aml.FirstName" value={this.props.search.firstName} />
                <BasicRow title={this.props.search.firstName === null ? "Search.Common.BusinessName" : "Search.Aml.LastName"} value={this.props.search.lastName} />
                <BasicRow title="Search.Aml.MiddleName" value={this.props.search.middleName} />
                <BasicRow title="Report.Aml.Subjects.Domicil" value={this.props.search.country} />
                {!isNullOrUndefined(this.props.search.birthDate) && <BasicRow title="Search.Common.BirthDate" value={this.props.search.birthDateFormated} />}
                {!isNullOrUndefined(this.props.search.birthYear) && <BasicRow title="Search.Common.BirthYear" value={this.props.search.birthYear} />}
                <BasicRow title="Search.Common.Gender" value={this.getGenderTranslation(this.props.search.gender)} />
                <BasicRow title="Search.Common.City" value={this.props.search.city} />
            </div>
        );
    }

    getGenderTranslation(gender) {
        if (isNullOrUndefined(gender))
            return null;
        switch (gender.toLowerCase()) {
            case "male": gender = "Male";
                break;
            case "female": gender = "Female";
                break;
            default: return null;
        }
        return this.props.translate(`Search.Common.Gender.${gender}`)
    }
}

export default withLocalize(AmlSearchCriteria);